// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const ProductAddOnStorefrontVisibility = {
  Always: {
    Name: 'Always',
    Value: 'always',
    Label: 'Always',
  },
  Hidden: {
    Name: 'Hidden',
    Value: 'hidden',
    Label: 'Hidden',
  },
} as const

export type ProductAddOnStorefrontVisibilityValue =
  (typeof ProductAddOnStorefrontVisibility)[keyof typeof ProductAddOnStorefrontVisibility]['Value']
